export default __webpack_public_path__ + "static/media/arrowRight.9d11749f.svg";